<button (click)="goBack()" mat-icon-button>
  <mat-icon svgIcon="icon-circled-chevron-left"></mat-icon>
</button>
